import * as StaticFilterInterface from '../static-filter/static-filter.i';
import { ECode } from '../static.e';
import * as Selector from '../../selector/selector.i';
export class CPeriod implements Selector.IPeriod {
  dateBeginPeriode = '';
  dateEndPeriod = '';

  constructor(period?: Selector.IPeriod) {
    if (period) {
      Object.assign(this, {
        dateBeginPeriode: period.dateBeginPeriode,
        dateEndPeriod: period.dateEndPeriod
      });
    }
  }
}
export class CDateSetPeriod implements StaticFilterInterface.IDateSetPeriod {
  id = '0';
  code = ECode.ANN;
  libelle = '';
  constructor(dateSetPeriod?: StaticFilterInterface.IDateSetPeriod) {
    if (dateSetPeriod) {
      Object.assign(this, {
        id: dateSetPeriod.id,
        code: dateSetPeriod.code,
        libelle: dateSetPeriod.libelle
      });
    }
  }
}

export class Sector implements Selector.ISector {
  id = '0';
  id_organisme_formation = '';
  libelle = '';

  constructor(sector?: Selector.ISector) {
    if (sector) {
      Object.assign(this, {
        id: sector.id,
        id_organisme_formation: sector.id_organisme_formation,
        libelle: sector.libelle
      });
    }
  }
}
